import * as React from 'react';
import { translate } from 'react-i18next';
import { IPortalPageSection, IPortalSectionProps } from 'models/portal/page/portalpagesection';
import { IPortalPageSectionItem } from 'models/portal/page/portalpagesectionitem';
import { PortalPageSectionItemRenderer } from 'components/PortalPage/SectionItems/SectionItemRenderer';
import * as c from 'models/constants';
import { followUser, getFollowingOrFollowersButtonsData, unfollowItem } from 'redux/modules/user/usercard';
import { IStore } from 'redux/IStore';
const { connect } = require('react-redux');
import { IFollowerDto } from 'models/common';
import { ISectionTextElement } from 'models/common/sectiontextelement';
import { IFollowCardItem } from 'models/verticalwidgetcards/followcard';
import { uniq } from 'helpers/common';
import { ISectionImageElement } from 'models/common/sectionimageelement';
require('./style.css');

interface IOwnProps extends IPortalSectionProps {
	t?: (key: string, options?: any) => string;
}

interface IProps extends IOwnProps {
	followingItems?: IFollowerDto[];
	getFollowingOrFollowersButtonsData?: () => void;
	followUser?: (id: string) => void;
	unfollowUser?: (id: string) => void;
}

function followItemsFromSection(section: IPortalPageSection): IFollowCardItem[] {
	if (!section || !section.items || !section.items.length) {
		return [];
	}
	const elements: Array<string | undefined> = section.items.map((item) => {
		if (!item || item.type !== c.PORTAL_PAGE_SECTION_ITEM_PROFILE || !item.elements) {
			return undefined;
		}
		const entityId = item.elements[6] && (item.elements[6] as ISectionTextElement).text;
		if (!entityId) {
			return undefined;
		}
		return entityId;
	});
	const entityIds: string[] = uniq(elements);
	return entityIds.map((entityId) => ({ entityId }));
}

@connect(
	(state: IStore) => ({
		followingItems: state.usercard.followingItems || [],
	}),
	(dispatch, ownProps: IOwnProps) => {
		const gfofbd = () =>
			dispatch(getFollowingOrFollowersButtonsData(followItemsFromSection(ownProps.section), true, false));
		return {
			getFollowingOrFollowersButtonsData: gfofbd,
			followUser: (id: string) => dispatch(followUser(id, false, gfofbd)),
			unfollowUser: (id: string) => dispatch(unfollowItem(id, c.NODE_TYPE_USER, false, false, gfofbd)),
		};
	},
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ViewType6 extends React.Component<IProps> {
	private ref: React.RefObject<HTMLDivElement>;
	private mainRef: React.RefObject<HTMLDivElement>;
	private othersRef: React.RefObject<HTMLDivElement>;

	constructor(props) {
		super(props);
		this.followItem = this.followItem.bind(this);
		this.unfollowItem = this.unfollowItem.bind(this);
		this.ref = React.createRef<HTMLDivElement>();
		this.mainRef = React.createRef<HTMLDivElement>();
		this.othersRef = React.createRef<HTMLDivElement>();
		this.onScroll = this.onScroll.bind(this);
	}

	public componentDidMount() {
		this.props.getFollowingOrFollowersButtonsData();
		document.addEventListener('scroll', this.onScroll);
		window.addEventListener('resize', this.onScroll);
		this.onScroll();
	}

	public componentWillUnmount() {
		document.removeEventListener('scroll', this.onScroll);
		window.removeEventListener('resize', this.onScroll);
	}

	private resetScrollStyles() {
		if (this.mainRef.current) {
			this.mainRef.current.style.removeProperty('position');
			this.mainRef.current.style.removeProperty('marginTop');
			this.mainRef.current.style.removeProperty('margin-top');
			this.mainRef.current.style.removeProperty('bottom');
		}
	}

	private onScroll() {
		if (typeof window === 'undefined') {
			return;
		}
		if (this.props.isAdmin || window.innerWidth < 900) {
			return this.resetScrollStyles();
		}
		if (!this.ref.current || !this.mainRef.current || !this.othersRef.current) {
			return;
		}
		const rect = this.ref.current.getBoundingClientRect();
		const fromBottom = Math.max(0, window.innerHeight - rect.bottom);
		const maxHeight = this.othersRef.current.offsetHeight;
		const itemHeight = this.mainRef.current.offsetHeight;
		const maxMargin = maxHeight - itemHeight;
		let marginTop = 0;
		if (rect.top < 0) {
			marginTop = Math.min(maxMargin, Math.max(0, -rect.top - fromBottom));
		}
		if (rect.top < 0 && rect.bottom > 0) {
			this.mainRef.current.style.position = 'fixed';
			this.mainRef.current.style.bottom = fromBottom + 0 + 'px';
		} else {
			this.mainRef.current.style.position = 'relative';
			this.mainRef.current.style.marginTop = marginTop + 'px';
			this.mainRef.current.style.bottom = '0';
		}
	}

	private followItem(type: string, id: string) {
		if (type.toLowerCase() !== 'user') {
			return;
		}
		this.props.followUser(id);
	}
	private unfollowItem(type: string, id: string) {
		if (type.toLowerCase() !== 'user') {
			return;
		}
		this.props.unfollowUser(id);
	}

	public render() {
		const { items, type } = this.props.section;
		const isNonEmptyElement = (element: ISectionTextElement | ISectionImageElement) =>
			element.redirectUrl || (element as ISectionImageElement).imageUrl || (element as ISectionTextElement).text;
		const renderedItems = items
			.filter((item) => item.type && item.elements.some(isNonEmptyElement))
			.map((item: IPortalPageSectionItem, index: number) => {
				const isFirstItemInRow: boolean = index === 1;
				const isLastItemInRow: boolean = index === items.length - 1 || (index + 1) % 4 === 0;
				return (
					<PortalPageSectionItemRenderer
						key={'portalpagesectionrenderer_' + (item ? item.type : 'empty') + '_' + index}
						portalPageSectionItem={item}
						isLastItemInRow={isLastItemInRow}
						isFirstItemInRow={isFirstItemInRow}
						sectionType={type}
						isDragging={false}
						followingItems={this.props.followingItems}
						followItem={this.followItem}
						unfollowItem={this.unfollowItem}
					/>
				);
			});

		const otherItems: JSX.Element = (
			<div className="row no-gutters otherItems" ref={this.othersRef}>
				{renderedItems.slice(1).map((item, index) => {
					return (
						<div key={index} className="col-6 col-xs-6">
							{item}
						</div>
					);
				})}
			</div>
		);

		return (
			<div className="portalPageSectionType6" ref={this.ref}>
				<div className="holder">
					<div className="mainHolder">
						<div className="mainItem" ref={this.mainRef}>
							{renderedItems[0]}
						</div>
					</div>
					{otherItems}
				</div>
			</div>
		);
	}
}

export { ViewType6 };
